class FullWidthVideo extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    if (!this.els?.video?.exists) return

    document.addEventListener('click', this.handleTrigger.bind(this))
  }

  handleTrigger (event) {
    // Check if the click was on a trigger element
    const clickedTrigger = event.target.closest(this.els.trigger.selector)

    if (clickedTrigger) {
      const clickedTriggerId = clickedTrigger.dataset.id
      const thisTriggerId = this.els.trigger.element.dataset.id

      // Only handle the open if the clicked trigger belongs to this component
      if (clickedTriggerId === thisTriggerId) {
        this.handleOpen()
      }

      return
    }

    // Check for inline modal close
    if (event.target.closest(this.els.close.selector)) {
      this.handleClose()
      return
    }

    // Check for external modal close
    if (
      this.externalEls?.close &&
      event.target.closest(this.externalEls.close.selector)
    ) {
      this.handleClose()
    }
  }

  handleOpen () {
    this.isOpen = true

    // Pause background video if it exists
    this.pauseBackgroundVideo()

    // Use external modal if available
    if (this.externalEls?.video?.exists) {
      this.populateExternalModal()
    } else {
      // Fallback to inline modal
      if (!this.els.source.element.src) {
        this.els.source.element.src = this.els.source.element.dataset.src
        this.els.video.element.load()
      }

      this.els.video.element.play()
    }
  }

  pauseBackgroundVideo () {
    // Find and pause any background videos in this component
    const backgroundVideos = this.querySelectorAll('.sec-FullWidthVideo_Video')
    backgroundVideos.forEach(video => {
      if (!video.paused) {
        video.pause()
        video.dataset.wasPlaying = 'true'
      }
    })
  }

  resumeBackgroundVideo () {
    // Find and resume any background videos that were playing
    const backgroundVideos = this.querySelectorAll('.sec-FullWidthVideo_Video')
    backgroundVideos.forEach(video => {
      if (video.dataset.wasPlaying === 'true') {
        video.play()
        delete video.dataset.wasPlaying
      }
    })
  }

  populateExternalModal () {
    const externalVideo = this.externalEls.video.element
    const sourceElement = this.els.source.element

    if (externalVideo && sourceElement) {
      const videoSrc = sourceElement.dataset.src
      const currentVideoSrc = externalVideo.querySelector('source')?.dataset.src

      // Check if this is the same video that was previously loaded
      const isSameVideo = videoSrc === currentVideoSrc && currentVideoSrc

      if (isSameVideo) {
        // Resume the existing video
        externalVideo.play()
      } else {
        // Clear any existing source elements in external video
        externalVideo.innerHTML = ''

        // Clone the source element to the external video
        const newSource = sourceElement.cloneNode(true)
        externalVideo.appendChild(newSource)

        // Set the src from data-src
        if (!newSource.src) {
          newSource.src = newSource.dataset.src
        }

        // Load and play the video
        externalVideo.load()
        externalVideo.play()
      }
    }
  }

  handleClose () {
    this.isOpen = false

    // Pause both inline and external videos
    if (this.els.video?.element) {
      this.els.video.element.pause()
    }

    if (this.externalEls?.video?.element) {
      this.externalEls.video.element.pause()
    }

    // Resume background video
    this.resumeBackgroundVideo()

    document.body.classList.remove('lyt-ModalOpen')
  }

  get isOpen () {
    return this._isOpen
  }

  set isOpen (boolean) {
    this._isOpen = boolean

    if (this.externalEls?.modal?.exists) {
      // Use external modal
      this.externalEls.modal.element.setAttribute(
        'aria-hidden',
        String(!boolean),
      )
    } else {
      // Fallback to inline modal
      this.setAttribute('data-modal-open', String(boolean))
      this.els.modal.element.setAttribute('aria-hidden', String(!boolean))
    }

    document.body.classList.add('lyt-ModalOpen')
  }
}

if (!customElements.get('full-width-video')) {
  customElements.define('full-width-video', FullWidthVideo)
}
